export class Config {
  static BASE_URL = "https://asna-ace.com/back-end/api/v0/";
  //static BASE_URL = "http://asna-api.codebnb.me/api/v0/";
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/config.ts